export const strings = {
  title: 'Create Rule',
  notes: 'Notes:',
};